<script setup lang="ts">
  import { isVNode } from 'vue'
  import { useToast } from './use-toast'
  import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from '.'

  const { toasts } = useToast()
</script>

<template>
  <ToastProvider>
    <Toast
      v-for="toast in toasts"
      v-bind="toast"
      :key="toast.id"
    >
      <component
        :is="toast.icon"
        v-if="toast.icon"
        :class="['h-5 w-5 flex-shrink-0', toast.iconClass]"
      />
      <div :class="['grid gap-1', toast.icon ? 'flex-1' : '']">
        <ToastTitle v-if="toast.title">
          {{ toast.title }}
        </ToastTitle>
        <template v-if="toast.description">
          <ToastDescription v-if="isVNode(toast.description)">
            <component :is="toast.description" />
          </ToastDescription>
          <ToastDescription v-else>
            <div class="whitespace-pre-wrap">{{ toast.description }}</div>
          </ToastDescription>
        </template>
        <ToastClose />
      </div>
      <component :is="toast.action" />
    </Toast>
    <ToastViewport />
  </ToastProvider>
</template>
